import React from "react";
import { BookOpenIcon, GiftIcon, CheckIcon, GlobeIcon, FlameIcon, ShieldCheckIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { Countdown } from "../Countdown";
import { bonuses } from "../../data/bonuses";
import { PRODUCT_IMAGE } from "../../data/content";
const SPOTS_LEFT = 7;
const FILLED = 93;
const perks = ["One-time payment", "Lifetime access", "No monthly subscriptions", "Instant digital delivery", "5 exclusive bonuses included"];
export function Offer() {
  return <section id="offer" className="w-full bg-sage px-3 py-16 sm:px-4 sm:py-20" data-id="element-203" data-mp="3f3i5oxy9kbvt">
      <div className="mx-auto max-w-2xl" data-id="element-204" data-mp="3juqg9xbby3ak">
        <div className="text-center" data-id="element-205" data-mp="3jvrzwq6evy3w">
          <span className="inline-flex items-center gap-2 rounded-full bg-danger px-4 py-1.5 text-[13px] font-bold uppercase tracking-wider text-white" data-id="element-206" data-mp="3nwu1hdnswm91">
            <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-207" data-mp="3sxhta1jut74b" /> Special launch offer
          </span>
          <h2 className="mt-5 font-serif text-[30px] font-bold leading-[1.15] text-ink sm:text-5xl" data-id="element-208" data-mp="1q58zdnocdk6">
            Here's Everything You'll Receive <em className="text-forest" data-id="element-209" data-mp="1fmdfuyb0o4bd">Today</em>
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl bg-white shadow-[0_20px_50px_-20px_rgba(15,76,69,0.45)] ring-2 ring-forest" data-id="element-210" data-mp="1fohti7ypwhou">
          <div className="bg-forest px-5 py-3 text-center text-[14px] font-bold uppercase tracking-wider text-white" data-id="element-211" data-mp="16lyszuiemh5r">
            Complete Biomagnetism Protocol Vault™
          </div>
          <img src={PRODUCT_IMAGE} alt="Everything included in the Biomagnetism Protocol Vault" className="mx-auto w-full max-w-md px-4 pt-4" data-id="element-212" data-mp="1zacrschbhhid" />

          <div className="px-5 pb-8 pt-4 sm:px-8" data-id="element-213" data-mp="1uimebxn32dmq">
            <ul className="divide-y divide-ink/10" data-id="element-214" data-mp="1pkku39dx889o">
              <li className="flex items-start justify-between gap-4 py-4" data-id="element-215" data-mp="1pjrxh18oez59">
                <div className="flex gap-3" data-id="element-216" data-mp="2n073gqpwh011">
                  <BookOpenIcon className="mt-0.5 h-5 w-5 shrink-0 text-forest" aria-hidden="true" data-id="element-217" data-mp="2n19vx32vfaj2" />
                  <div data-id="element-218" data-mp="2i75ko7mkogc6">
                    <p className="font-bold text-ink" data-id="element-219" data-mp="315h3c2dpbbsg">Protocol Vault™ — 6 Premium Volumes</p>
                    <p className="mt-0.5 text-[14px] leading-snug text-muted" data-id="element-220" data-mp="364kc9xwsy25p">Learning pathways, visual references, templates, checklists & a 30-day roadmap.</p>
                  </div>
                </div>
                <s className="shrink-0 font-semibold text-muted" data-id="element-221" data-mp="2wer0avsqzl0x">$49</s>
              </li>
              {bonuses.map(b => <li key={b.number} className="flex items-start justify-between gap-4 py-3.5" data-id="element-222" data-mp="2iepyne4ns9ke">
                  <div className="flex gap-3" data-id="element-223" data-mp="2nece7u7ym1wd">
                    <GiftIcon className="mt-0.5 h-5 w-5 shrink-0 text-gold" aria-hidden="true" data-id="element-224" data-mp="2nbzm4o8hmb5l" />
                    <p className="text-[15px] font-medium leading-snug text-ink" data-id="element-225" data-mp="29g4cl8zzacev">
                      <span className="font-bold" data-id="element-226" data-mp="2dgepz6q3o53r">Bonus #{b.number}:</span> {b.title}
                    </p>
                  </div>
                  <s className="shrink-0 font-semibold text-muted" data-id="element-227" data-mp="7l3p2fu3t2iv">${b.value}</s>
                </li>)}
            </ul>

            <div className="mt-2 flex items-center justify-between rounded-2xl bg-cream px-4 py-3" data-id="element-228" data-mp="1w62cs3xa5dbq">
              <span className="text-[14px] font-bold uppercase tracking-wide text-ink" data-id="element-229" data-mp="1s5rym3zc3gls">Total suggested value</span>
              <s className="text-xl font-bold text-danger" data-id="element-230" data-mp="25xf5syute9jc">$150</s>
            </div>

            <div className="mt-7 text-center" data-id="element-231" data-mp="215f0srzw0qfw">
              <p className="text-[16px] text-muted" data-id="element-232" data-mp="213kepacvqsa8">But you don't have to pay that amount. Get it today for just…</p>
              <p className="mt-2 font-serif text-[80px] font-bold leading-none text-forest sm:text-[96px]" data-id="element-233" data-mp="2avgqtpbswixg">
                $27<span className="ml-1 align-top font-sans text-xl font-bold text-ink" data-id="element-234" data-mp="2ouzn9kv925tx">USD</span>
              </p>
              <ul className="mx-auto mt-5 grid max-w-sm gap-2 text-left" data-id="element-235" data-mp="2jvn357vrjcv1">
                {perks.map(p => <li key={p} className="flex items-center gap-2.5 text-[15px] font-medium text-ink" data-id="element-236" data-mp="ui9rexlbmmjw">
                    <CheckIcon className="h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-237" data-mp="pj6wi5z21wpn" /> {p}
                  </li>)}
              </ul>
            </div>

            <div className="mt-7" data-id="element-238" data-mp="vxm9xq46ff8a">
              <CtaButton label="Yes! I want the Biomagnetism Protocol Vault" data-id="element-239" data-mp="vwt18jlnqfni" />
            </div>

            <Countdown data-id="element-240" data-mp="10y06aawf10qh" />

            <div className="mt-7 rounded-2xl border-2 border-danger/30 bg-orange-50 p-4" data-id="element-241" data-mp="10vnt0b1lrejr">
              <p className="text-center text-[15px] font-bold text-danger" data-id="element-242" data-mp="15uh45wtf2tgr">
                Only {SPOTS_LEFT} spots left at the promotional price!
              </p>
              <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-orange-100" role="progressbar" aria-valuenow={FILLED} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots taken" data-id="element-243" data-mp="d8nzfhok94rc">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${FILLED}%`
              }} data-id="element-244" data-mp="mzaacylc173p" />
              </div>
              <p className="mt-2 text-center text-[13px] text-ink/70" data-id="element-245" data-mp="3lnfvj1fzkhe0">{FILLED}% of promotional spots already claimed</p>
            </div>

            <p className="mt-5 flex items-start justify-center gap-2 text-center text-[14px] leading-relaxed text-muted" data-id="element-246" data-mp="3j301752f0hr8">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-247" data-mp="3e586k3adyhjc" />
              <span data-id="element-248" data-mp="394aqbw8xrxkh">Currency conversion is automatic — at checkout you'll see the price in your local currency.</span>
            </p>
            <p className="mt-2 flex items-center justify-center gap-2 text-[13px] text-muted" data-id="element-249" data-mp="345r2trep2dq0">
              <ShieldCheckIcon className="h-4 w-4 text-forest" aria-hidden="true" data-id="element-250" data-mp="305yu9epaw7kn" /> Secure checkout · 7-day money-back guarantee
            </p>
          </div>
        </div>
      </div>
    </section>;
}